import { Tag } from '@src/atoms/Tag';
import { Text } from '@src/atoms/Text';
import { TNoOfLinesAdaptive } from '@src/models/adaptive';
import React, { FC, MouseEvent } from 'react';
import { FiltersController } from '../../FiltersController';
import { Box } from '@src/atoms/Box';
import { closeFilterTag } from './utils';
import { useSyncFilterValue } from '../../useSyncValue';
import { IconV2 } from '@src/atoms/IconV2';
import { classnames } from '@src/utils/classnames';

import styles from './FiltersBadgeSingleTag.module.scss';

interface IFiltersBadgeSingleTagHocProps
  extends Pick<IFiltersBadgeSingleTagProps, 'title' | 'text' | 'classes' | 'href' | 'noOfLines' | 'style'> {
  handleClick: (e: MouseEvent<HTMLSpanElement>) => void;
  index?: number;
  controller: FiltersController;
  filterName?: string;
  doNotGroup?: boolean;
  singlePredicate?: boolean;
}

export const FiltersBadgeSingleTagHoc: FC<IFiltersBadgeSingleTagHocProps> = ({
  handleClick,
  index,
  controller,
  filterName,
  doNotGroup,
  singlePredicate,
  ...props
}) => {
  const value = useSyncFilterValue({ controller });

  const handleClose = () => {
    closeFilterTag(controller, doNotGroup, singlePredicate, filterName, index, value);
  };

  return <FiltersBadgeSingleTag onClose={handleClose} onClick={handleClick} {...props} />;
};

interface IFiltersBadgeSingleTagProps {
  onClose: () => void;
  classes?: string;
  style?: React.CSSProperties;
  onClick?: (e: MouseEvent<HTMLSpanElement>) => void;
  title: string;
  text?: string;
  href?: string;
  noOfLines?: TNoOfLinesAdaptive;
}

// Компонент для отображения тега фильтра
export const FiltersBadgeSingleTag: FC<IFiltersBadgeSingleTagProps> = ({
  classes: propsClasses,
  style,
  title,
  text,
  href,
  noOfLines,
  onClose,
  onClick,
}) => {
  const classes = classnames(styles.root, propsClasses);

  return (
    <Tag id="FiltersBadge" className={classes} style={style} onClick={onClick}>
      <Box alignItems="center">
        <Text id="FiltersBadgeTitle" className={styles.text} noOfLines={noOfLines} color="basicBlack">
          {title}
        </Text>
        {text && (
          <Text id="FiltersBadgeText" className={styles.text} noOfLines={noOfLines} color={'basicGreySemiDark'}>
            {`: ${text}`}
          </Text>
        )}
      </Box>

      <IconV2 name="bold-delete" view="basicBlack" size="sm" href={href} onClick={onClose} />
    </Tag>
  );
};
